"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constant2 = require("./constant");

var _chip = _interopRequireDefault(require("./chip.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ChipContainer = _styledComponents.default.div.withConfig({
  displayName: "Chip__ChipContainer",
  componentId: "sc-11x6iem-0"
})(function (_ref) {
  var bgColor = _ref.bgColor,
      borderColor = _ref.borderColor,
      hoverBgColor = _ref.hoverBgColor,
      hoverBorderColor = _ref.hoverBorderColor,
      hoverTextColor = _ref.hoverTextColor,
      activeBgColor = _ref.activeBgColor,
      activeBorderColor = _ref.activeBorderColor,
      activeTextColor = _ref.activeTextColor,
      fontSize = _ref.fontSize,
      theme = _ref.theme,
      disabled = _ref.disabled,
      customPadding = _ref.customPadding,
      as = _ref.as,
      activeChipColor = _ref.activeChipColor;
  return "\n        display: inline-flex;\n        align-items: center;\n        background-color: ".concat(theme.backgroundColor[bgColor], ";\n        border: 1px solid ").concat(theme.colors[borderColor], ";\n        border-radius: ").concat(theme.borderRadius.large, ";\n        cursor: pointer;\n        padding: ").concat(customPadding ? "".concat(customPadding) : "".concat(theme.space.tiny, " ").concat(theme.space.small), ";\n        transition: ease-out 0.2s;\n        white-space: nowrap;\n        & *{\n            transition: ease-out 0.2s;\n\n        }\n\n        & #chipText{\n            font-size: ").concat(theme.fontSize[fontSize], "\n        }\n\n        ").concat(disabled ? "\n          background-color: ".concat(theme.backgroundColor.greyLighter, ";\n          border-color: ").concat(theme.colors.greyLight, ";\n          cursor: not-allowed;\n          & *{\n            color: ").concat(theme.colors.greyMedium, "\n          }\n        ") : "\n        &:hover:not(.active){\n          background-color: ".concat(theme.backgroundColor[hoverBgColor], ";\n          border-color: ").concat(theme.colors[hoverBorderColor], ";\n\n          & * {\n            color: ").concat(theme.colors[hoverTextColor], ";\n          }\n      }\n        "), "\n\n        &.active{\n            background-color: ").concat(activeChipColor || theme.backgroundColor[activeBgColor], ";\n            border-color: ").concat(activeChipColor || theme.colors[activeBorderColor], ";\n\n            & * {\n              color: ").concat(theme.colors[activeTextColor], ";\n            }\n        }\n\n        ").concat(as && as === 'a' && 'text-decoration: none;', "\n    ");
});

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "Chip__IconContainer",
  componentId: "sc-11x6iem-1"
})(function (_ref2) {
  var theme = _ref2.theme,
      textPadding = _ref2.textPadding;
  return "\n    display: inline-block;\n    line-height: ".concat(theme.space.XXSmall, ";\n    padding: ").concat(textPadding, ";\n    ");
});

IconContainer.displayName = 'IconContainer';
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "Chip__StyledIcon",
  componentId: "sc-11x6iem-2"
})(function (_ref3) {
  var direction = _ref3.direction,
      theme = _ref3.theme,
      withPadding = _ref3.withPadding,
      fontsize = _ref3.fontsize;
  return "\n        ".concat(direction === _constant2.ICON_DIRECTION.right ? "margin-left: ".concat(theme.space.XXSmall, "; padding: ").concat(withPadding ? 5 : 0, "px;") : "margin-right: ".concat(theme.space.XXSmall, ";\n            font-size:").concat(theme.fontSize[fontsize], "\n            "), "\n    ");
});

var Chip = function Chip(props) {
  var children = props.children,
      leftIcon = props.leftIcon,
      rightIcon = props.rightIcon,
      textColor = props.textColor,
      backgroundColor = props.backgroundColor,
      borderColor = props.borderColor,
      hoverTextColor = props.hoverTextColor,
      hoverBackgroundColor = props.hoverBackgroundColor,
      hoverBorderColor = props.hoverBorderColor,
      activeTextColor = props.activeTextColor,
      activeBackgroundColor = props.activeBackgroundColor,
      activeBorderColor = props.activeBorderColor,
      fontSize = props.fontSize,
      onChipClick = props.onChipClick,
      onIconClick = props.onIconClick,
      url = props.url,
      newTab = props.newTab,
      disabled = props.disabled,
      accessible = props.accessible,
      active = props.active,
      iconUsesTextColor = props.iconUsesTextColor,
      theme = props.theme,
      customProperties = props.customProperties,
      customPadding = props.customPadding,
      _props$as = props.as,
      as = _props$as === void 0 ? null : _props$as,
      _props$href = props.href,
      href = _props$href === void 0 ? null : _props$href,
      leftImg = props.leftImg,
      rightImg = props.rightImg,
      isMobile = props.isMobile,
      withPadding = props.withPadding,
      iconSize = props.iconSize,
      activeChipColor = props.activeChipColor;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var imgPadding = (leftImg || rightImg) && _constant2.IMG.padding;
  var textPadding = leftImg ? _constant2.IMG.lpadding : _constant2.IMG.rpadding;

  var onClickHandler = function onClickHandler(e) {
    if (onChipClick) {
      onChipClick(e);
    }

    if (url) {
      if (newTab === 'TRUE' || newTab === '' || newTab) {
        window.open(url, '_blank');
      } else {
        window.open(url, '_parent');
      }
    }
  };

  var onIconClickHandler = function onIconClickHandler(e) {
    if (onIconClick) {
      e.stopPropagation();
      onIconClick(e);
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ChipContainer, (0, _extends2.default)({
      bgColor: backgroundColor,
      borderColor: borderColor,
      hoverBgColor: hoverBackgroundColor,
      hoverBorderColor: hoverBorderColor,
      hoverTextColor: hoverTextColor,
      activeTextColor: activeTextColor,
      activeBgColor: activeBackgroundColor,
      activeBorderColor: activeBorderColor,
      onClick: !disabled ? onClickHandler : null,
      onKeyDown: !disabled ? function (e) {
        return _utilities.default.keyDownHandler(e, onClickHandler, _constant.KEY_CODE.ENTER);
      } : null,
      className: active ? 'active' : null,
      fontSize: fontSize,
      tabIndex: tabIndex,
      disabled: disabled
    }, customProperties, {
      customPadding: customPadding || imgPadding
    }, !!as && {
      as: as,
      href: href
    }, {
      activeChipColor: activeChipColor
    }), leftIcon && /*#__PURE__*/_react.default.createElement(IconContainer, null, /*#__PURE__*/_react.default.createElement(StyledIcon, {
      icon: leftIcon,
      direction: _constant2.ICON_DIRECTION.left,
      color: iconUsesTextColor ? textColor : 'greyMediumDark',
      fontsize: "normal",
      accessible: false
    })), leftImg && /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: leftImg,
      height: isMobile ? _constant2.IMG.height_mobile : _constant2.IMG.height,
      width: isMobile ? _constant2.IMG.width_mobile : _constant2.IMG.width,
      radius: _constant2.IMG.radius,
      theme: theme
    }), /*#__PURE__*/_react.default.createElement(IconContainer, {
      textPadding: (leftImg || rightImg) && textPadding
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: textColor,
      accessible: false,
      bold: true,
      customProperties: {
        id: 'chipText'
      }
    }, children)), rightImg && /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: rightImg,
      height: isMobile ? _constant2.IMG.height_mobile : _constant2.IMG.height,
      width: isMobile ? _constant2.IMG.width_mobile : _constant2.IMG.width,
      radius: _constant2.IMG.radius,
      theme: theme
    }), rightIcon && /*#__PURE__*/_react.default.createElement(IconContainer, {
      onClick: !disabled && onIconClick ? function (e) {
        return onIconClickHandler(e);
      } : null
    }, /*#__PURE__*/_react.default.createElement(StyledIcon, {
      icon: rightIcon,
      direction: _constant2.ICON_DIRECTION.right,
      color: iconUsesTextColor ? textColor : 'greyMediumDark',
      fontsize: iconSize || 'normal',
      accessible: false,
      withPadding: withPadding
    })));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Chip.propTypes = _chip.default.PropTypes;
Chip.defaultProps = _chip.default.DefaultProps;
var _default = Chip;
exports.default = _default;